export default __webpack_public_path__ + "static/le-frise-84f54c1aaacb3c58d78b9775da3eeb97.png";